import styles from './styles.module.css';
import { useTranslation } from 'react-i18next';
import { features } from './data';
import BG from "src/assets/images/home/features/bg.webp";
import Title from '../../../components/title/Title';
import { Element } from 'react-scroll';
import { colors } from 'src/constants/colors';

export default function Features() {
    const { t, i18n } = useTranslation("home");
    const currentLang = i18n.language as 'ar' | 'en';

    return (
        <Element name="features" className={[styles.features__section, currentLang.includes("ar") ? styles.is_rtl : null].join(" ")} style={{ backgroundImage: `url(${BG})` }}>
            <div className="container">
                <Title lgTitle={t("features.title")}
                    smTitle={t("features.sub_title")}
                    smTitleColor={colors.primaryLight}
                    lgTitleColor={"#fff"} />

                <div className="row mt-3 pt-2">
                    {features.map((item, index) => (
                        <div
                            key={`feature-key-${index}`}
                            className="col-lg-4 col-md-6 col-12 mx-auto px-lg-2"
                            data-aos="fade-up"
                            data-aos-delay={index * 80} // delay each card by 150ms
                        >
                            <div className={styles.card}>
                                <item.icon className={styles.icon} />
                                <h4>{item.title[currentLang]}</h4>
                                <p className='global-p'>{item.content[currentLang]}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </Element>
    );
}
